export default "__VITE_ASSET__be11a5e8__"